import balanceText from 'balance-text';

[
  '.header__heading',
  '.header__subheading',
  '.section__heading',
  '.section__subheading',
  '.interrupter__heading',
].forEach((selector) => balanceText(selector, { watch: true }));
